import { ChangeDetectorRef, Component, ViewChild, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { MaintenanceService } from '../../../services/maintenanceService';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ExportDataService } from '../../../../shared';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatMenuTrigger } from '@angular/material/menu';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
import { MaintenanceTableV4Component } from '../../maintenance-table-v4/maintenance-table-v4.component';
import { AppModalComponent } from '../../../../shared/elements/app-modal/app-modal.component';
import { AddEditForecastServiceComponent } from './add-edit-forecast-service/add-edit-forecast-service.component';

@Component({
    selector: 'app-forecast-service-managment-table',
    templateUrl: './forecast-service-managment-table.component.html',
    styleUrl: './forecast-service-managment-table.component.css',
    imports: [MaintenanceTableV4Component, AppModalComponent, AddEditForecastServiceComponent],
    schemas: [NO_ERRORS_SCHEMA],
})
export class ForecastServiceManagmentTableComponent implements OnInit {
  forecastServiceData:any = [];
  dataSource:MatTableDataSource<any>  = new MatTableDataSource([]);
  @ViewChild('addEditForsecastServiceModal') forecastModal;
  showForecastModal:boolean = false;
  selectedEditData = null;
  isEdit = false;
  rateCardYear:number;
  showLoader: boolean = true;
  category:any;
  publicPrivate:any;
  uniqueCategory:any[]=[];
  allRowsExpanded: boolean = false;
  isExpandIconAtStart:boolean = true;
  TABLE_COLUMNS: any = [
    {
      key: 'Expand_Icon',
      labelKey: "Expand_Icon",
      label: '',
      width: '3% !important',
      align: 'center !important',
      padding: '0.312rem 0.312rem 0.312rem 0.312rem !important'
    },
    {
      key: 'SRVDESC',
      width: '13% !important',
      label: 'SV Description',
      filter: true,
      align: 'left !important',
      padding: '0.312rem 0.312rem 0.312rem 0rem !important',
      uomPaddingLeft: '2.2rem !important',
      showUOMrateData: true,
      sortable: true
    },
    {
      key: 'Service',
      labelKey: "Service",
      label: 'Service',
      width: '8% !important',
      align: 'left !important',
      filter: true,
      sortable: true,
      padding: '0.312rem 0.312rem 0.312rem 0rem !important',
    },
    {
      key: 'Public_Private_Cloud',
      label: 'Public/Private Cloud',
      width: '10% !important',
      align: 'left !important',
      padding: '0.312rem 0.312rem 0.312rem 0 !important',
      filter: true,
      sortable: true
    },
    {
      key: 'Category',
      label: 'Category',
      width: '7% !important',
      align: 'left !important',
      filter: true,
      sortable: true,
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    }, 
    {
      key: 'App_NonApp',
      label: 'App/Non-App',
      width: '7% !important',
      align: 'left !important',
      filter: true,
      sortable: true,
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    },
    {
      key: 'Users',
      label: 'Service Owner Details',
      width: '16% !important',
      align: 'left !important',
      filter: true,
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    },
    {
      key: 'Edit_TOH',
      label: 'Edit TOH',
      width: '6% !important',
      align: 'left !important',
      filter: true,
      sortable: true,
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    },
    {
      key: 'SRV_Disable',
      label: 'SRV Disable',
      width: '7% !important',
      align: 'left !important',
      filter: true,
      sortable: true,
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    },
    {
      key: 'Complex_Services',
      labelKey: "Complex_Services",
      label: ' Complex Services',
      width: '8% !important',
      align: 'left !important',
      filter: true,
      sortable: true,
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    },
    {
      key: 'UI_Comments',
      label: 'UI Comments',
      width: '8% !important',
      align: 'left !important',
      filter: true,
      sortable: true,
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    },
    {
      key: 'Actions',
      label: 'Actions',
      width: '7% !important',
      align: 'center !important',
      padding: '0.312rem 0.312rem 0.312rem 0 !important'
    }
  ];

  TABLE_CONFIG: any = {
    pageSize: [10, 20, 40],
    pageIndex: 0,
    totalItems: 0,
    selection: true,
    edit: true,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: true,
    innerTableEdit: false,
  };
  expandAll: string = 'false';
  expanded_columns: any = [

    {
      key: 'Year',
      labelKey: 'Year',
      label: 'Year',
      filter: true,
      width: '25% !important',
    },
    {
      key: 'Unit_of_Measure',
      labelKey: "Unit_of_Measure",
      label: 'Unit of Measure',
      width: '25% !important',
    },
    {
      key: 'Rate',
      labelKey: "Rate",
      label: 'Rate',
      width: '25% !important',
    },
    {
      key: 'Rate_marginless',
      labelKey: "Rate_marginless",
      label: 'Rate Marginless',
      width: '25% !important',
    },
  ];
  constructor(public maintenanceService: MaintenanceService,private cdr:ChangeDetectorRef , private sanitizer:DomSanitizer,private exportService: ExportDataService, private toaster: ToastrService){
  }

  ngOnInit(): void {
    this.getForecastServiceData();
  
  }

  getForecastServiceData(){
    this.showLoader = true; // Set showLoader to true initially
    //clear datasource
    this.dataSource = new MatTableDataSource([]);
    this.maintenanceService.getForecastServiceData().subscribe(
      (res: Array<any>) => {
        if (res && res.length > 0) {
          this.expandAll = 'false';
          this.allRowsExpanded = false;
          res = res.map((val)=> {
            val.Users = this.handleServiceOwner(val);
            return val
          });
          this.forecastServiceData = res;
          this.rateCardYear = res[0].Rate_Card_Year;
          this.dataSource = new MatTableDataSource(res);
          this.dataSource.data.forEach((val) => {
            val.service_year_list = this.sortServiceYearList(val.service_year_list);
            val.childDataSource = new MatTableDataSource(val.service_year_list);
          });
          this.category = res.map((item) => item.Category);
          this.uniqueCategory = [...new Set(this.category)];
          this.publicPrivate = res.map((item) => item.Public_Private_Cloud);
        }
        this.showLoader = false; // Set showLoader to false after success
      },
      (error) => {
        this.handleErrors(error);
        this.showLoader = false; // Set showLoader to false after error
      }
    );
  }

  // Helper function to sort service year list
  sortServiceYearList(list: any[]): any[] {
    return Array.isArray(list) ? list.sort((a, b) => a.Year - b.Year) : [];
  }

  //convert Service owner details into array

  handleServiceOwner(val: any) {
    if (val && val.Service_Owner_Name && val.Service_Owner_msid) {
      const serviceOwnerNameArr:Array<string> = val.Service_Owner_Name.split(';').map(name => name.trim());
      const serviceOwnerMSIDarr:Array<string> = val.Service_Owner_msid.split(',').map(id => id.trim());
      const ownerArr = serviceOwnerNameArr.map((el,index)=>{
        const details = {
          displayName : el,
          msid: serviceOwnerMSIDarr[index]
        }
        return details
      })
      return ownerArr;
    }
    return [];
  }
  //Handle the errors while fetching the data
  handleErrors(error: any) {
    console.log(error);
    this.showLoader = false;
    this.toaster.error('Error While Fetching Data', '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }

  exportToExcel() {
    if (!this.forecastServiceData) {
      console.warn('No data available to export.');
      return;
    }

    const exportData = [];
    this.forecastServiceData.forEach((val) => {
      if (val.service_year_list.length > 0) {

        val.service_year_list.forEach(element => {
          const exports = {};
          exports['Service'] = val.Service;
          exports['SV Desc'] = val.SRVDESC;
          exports['Public/Private_Cloud'] = val.Public_Private_Cloud;
          exports['Category'] = val.Category;
          exports['App/NonApp'] = val.App_NonApp;
          exports['Service Owner MSID'] = val.Service_Owner_msid;
          exports['Service Owner Name'] = val.Service_Owner_Name;
          exports['Service Owner Email'] = val.Service_Owner_Email;
          exports['Edit TOH'] = val.Edit_TOH;
          exports['SRV Disable'] = val.SRV_Disable;
          exports['Comments'] = val.Coments;
          exports['I flag'] = val.I_Flag;
          exports['External Link'] = val.External_Link;
          exports['UI Comments'] = val.UI_Comments;
          exports['Year'] = element['Year'];
          exports['Unit of Measure'] = element['Unit_of_Measure'];
          exports['Rate'] = element['Rate'];
          exports['Rate Marginless'] = element['Rate_marginless'];
          exportData.push(exports);
        });
      }else {
        const exports = {};
          exports['Service'] = val.Service || '';
          exports['SV Desc'] = val.SRVDESC || '';
          exports['Public/Private_Cloud'] = val.Public_Private_Cloud || '';
          exports['Category'] = val.Category || '';
          exports['App/NonApp'] = val.App_NonApp || '';
          exports['Service Owner MSID'] = val.Service_Owner_msid || '';
          exports['Service Owner Name'] = val.Service_Owner_Name || '';
          exports['Service Owner Email'] = val.Service_Owner_Email || '';
          exports['Edit TOH'] = val.Edit_TOH || '';
          exports['SRV Disable'] = val.SRV_Disable || '';
          exports['Comments'] = val.Comments || '';
          exports['Complex Services'] = val.Complex_Services || '';
          exports['I flag'] = val.I_Flag || '';
          exports['External Link'] = val.External_Link || '';
          exports['UI Comments'] = val.UI_Comments || '';
          exportData.push(exports);
      }
    });
    this.exportService.exportToExcel('Infra Forecast Service', [exportData], ['Forecast Service']);
  }

  onEdit(element) {
    this.selectedEditData = element;
    this.isEdit = true;
    this.showForecastModal = true;
    this.forecastModal.show();
  }

  hideModal(){
    this.showForecastModal = false;
    this.forecastModal.hide();
  }

  refreshTableData(ev){
    this.hideModal();
    this.maintenanceService.deleteCachedData('getForecastServiceData'); // Clear cached data to ensure fresh data is fetched
    this.getForecastServiceData();
  }

  closeModal(){
    this.showForecastModal = false;
  }

  collapseAllFunc(data) {
    this.allRowsExpanded = data;
  }

  expandAllFunc() {
    if (this.expandAll == 'true' || this.allRowsExpanded == true) {
      if (this.expandAll == 'false')
        this.expandAll = 'false1';
      else
        this.expandAll = 'false';
      this.allRowsExpanded = false;
    }
    else {
      this.expandAll = 'true';
      this.allRowsExpanded = true;
    }
  }

}
